module.exports = __webpack_public_path__ + "c05c6181c1ddb33d1391a51a0cbfe2c9.pdf";